export const paytmService = {
    getLoanDetails,
    postInitialOrder,
    validatePaymentLink
}

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

function getLoanDetails(ID, TOKEN) {
    const requestOptions = {
        method: 'GET',
        headers:
        {
            'Content-Type': 'application/json',
            "token": TOKEN
        },
    };

    return fetch(`${REACT_APP_API_URL}/api/v1/disbursed_loan_accounts/${ID}`, requestOptions).then(handleResponse);
}

function postInitialOrder(initialOrder, TOKEN) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', "token": TOKEN },
        body: JSON.stringify(initialOrder)
    };
    return fetch(`${REACT_APP_API_URL}/api/v1/payments/initiate_order`, requestOptions).then(handleResponse);
}

function validatePaymentLink(uuid, TOKEN) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', "token": TOKEN }
    };
    return fetch(`${REACT_APP_API_URL}/api/v1/payment_links/payment_details?uuid=${uuid}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.errors) || response.statusText;
            return Promise.reject(error || 'Internal Server Error');
        }
        return data;
    });
}